import createPopup from "./createPopup.js";
import createWeekNumbers from "./createWeekNumbers.js";
import generateDate from "../helpers/generateDate.js";
import getWeekNumber from "./getWeekNumber.js";
const createDays = (self) => {
  var _a, _b;
  const daysEls = self.HTMLElement.querySelectorAll(`.${self.CSSClasses.days}`);
  const weekNumbersEls = self.HTMLElement.querySelectorAll(`.${self.CSSClasses.weekNumbers}`);
  const initDate = new Date(self.selectedYear, self.selectedMonth, 1);
  const templateDayEl = document.createElement("div");
  const templateDayBtnEl = document.createElement("button");
  templateDayEl.className = self.CSSClasses.day;
  templateDayBtnEl.className = self.CSSClasses.dayBtn;
  templateDayBtnEl.type = "button";
  (_a = self.selectedDates) == null ? void 0 : _a.sort((a, b) => +new Date(a) - +new Date(b));
  daysEls.forEach((_, index) => {
    const selectedMonth = new Date(initDate.setMonth(self.selectedMonth + index)).getMonth();
    const selectedYear = new Date(initDate.setFullYear(self.selectedYear, self.selectedMonth + index)).getFullYear();
    const firstDay = new Date(selectedYear, selectedMonth, 1);
    const daysSelectedMonth = new Date(selectedYear, selectedMonth + 1, 0).getDate();
    let firstDayWeek = Number(firstDay.getDay());
    if (self.settings.iso8601) firstDayWeek = Number((firstDay.getDay() !== 0 ? firstDay.getDay() : 7) - 1);
    if (self.settings.selection.day && ["single", "multiple", "multiple-ranged"].includes(self.settings.selection.day)) {
      daysEls[index].classList.add(self.CSSClasses.daysSelecting);
    }
    daysEls[index].innerHTML = "";
    const setDayModifier = (dayEl, dayBtnEl, dayID, date, otherMonth) => {
      if (self.rangeMin > date || self.rangeMax < date) {
        dayBtnEl.classList.add(self.CSSClasses.dayBtnDisabled);
        dayBtnEl.tabIndex = -1;
      }
      if (self.settings.visibility.weekend && (dayID === 0 || dayID === 6)) {
        dayBtnEl.classList.add(self.CSSClasses.dayBtnWeekend);
      }
      if (Array.isArray(self.selectedHolidays)) {
        self.selectedHolidays.forEach((holiday) => {
          if (holiday === date) {
            dayBtnEl.classList.add(self.CSSClasses.dayBtnHoliday);
          }
        });
      }
      let thisToday = self.date.today.getDate();
      let thisMonth = self.date.today.getMonth() + 1;
      thisToday = thisToday < 10 ? `0${thisToday}` : thisToday;
      thisMonth = thisMonth < 10 ? `0${thisMonth}` : thisMonth;
      const thisDay = `${self.date.today.getFullYear()}-${thisMonth}-${thisToday}`;
      if (self.settings.visibility.today && dayBtnEl.dataset.calendarDay === thisDay) {
        dayBtnEl.classList.add(self.CSSClasses.dayBtnToday);
      }
      if (self.selectedDates && self.selectedDates.indexOf(date) === 0) {
        if (self.settings.selection.day === "multiple-ranged" && self.selectedDates.length > 1) {
          dayEl.classList.add(self.CSSClasses.daySelectedFirst);
          if (self.selectedDates[0] === self.selectedDates[1]) {
            dayEl.classList.add(self.CSSClasses.daySelectedLast);
          }
        } else {
          dayEl.classList.add(self.CSSClasses.daySelected);
        }
        dayBtnEl.classList.add(self.CSSClasses.dayBtnSelected);
      } else if (self.selectedDates && self.selectedDates[0] && self.selectedDates.indexOf(date) === self.selectedDates.length - 1) {
        dayEl.classList.add(self.CSSClasses.daySelected);
        if (self.settings.selection.day === "multiple-ranged") {
          dayEl.classList.add(self.CSSClasses.daySelectedLast);
        } else {
          dayEl.classList.add(self.CSSClasses.daySelected);
        }
        dayBtnEl.classList.add(self.CSSClasses.dayBtnSelected);
      } else if (self.selectedDates && self.selectedDates.indexOf(date) > 0 && self.settings.selection.day === "multiple-ranged") {
        dayEl.classList.add(self.CSSClasses.daySelectedIntermediate);
        dayBtnEl.classList.add(self.CSSClasses.dayBtnSelected);
        dayBtnEl.classList.add(self.CSSClasses.dayBtnIntermediate);
      } else if (self.selectedDates && self.selectedDates.indexOf(date) > 0) {
        dayEl.classList.add(self.CSSClasses.daySelected);
        dayBtnEl.classList.add(self.CSSClasses.dayBtnSelected);
      }
      if (Array.isArray(self.rangeDisabled) && self.rangeDisabled[0]) {
        self.rangeDisabled.forEach((dateDisabled) => {
          if (dateDisabled === date) {
            dayBtnEl.classList.add(self.CSSClasses.dayBtnDisabled);
            dayBtnEl.tabIndex = -1;
          }
        });
      }
      if (!self.settings.selection.month && otherMonth) {
        dayBtnEl.classList.add(self.CSSClasses.dayBtnDisabled);
        dayBtnEl.tabIndex = -1;
      }
      if (!self.settings.selection.year && (/* @__PURE__ */ new Date(`${date}T00:00:00`)).getFullYear() !== selectedYear) {
        dayBtnEl.classList.add(self.CSSClasses.dayBtnDisabled);
        dayBtnEl.tabIndex = -1;
      }
    };
    const createDay = (dayText, dayID, date, otherMonth, modifier) => {
      var _a2, _b2, _c, _d, _e, _f, _g, _h, _i;
      const dayEl = templateDayEl.cloneNode(true);
      const dayBtnEl = templateDayBtnEl.cloneNode(true);
      if (modifier) dayBtnEl.classList.add(modifier);
      dayBtnEl.innerText = dayText;
      dayBtnEl.dataset.calendarDay = date;
      if (self.settings.visibility.weekNumbers) {
        const weekNumber = getWeekNumber(date, self.settings.iso8601);
        if (!weekNumber) return;
        dayBtnEl.dataset.calendarWeekNumber = `${weekNumber.week}`;
      }
      if (((_a2 = self.rangeEnabled) == null ? void 0 : _a2[0]) && self.settings.range.disableAllDays && !((_b2 = self.rangeDisabled) == null ? void 0 : _b2.includes(date))) {
        (_c = self.rangeDisabled) == null ? void 0 : _c.push(date);
      }
      if (((_d = self.rangeEnabled) == null ? void 0 : _d[0]) && ((_e = self.rangeDisabled) == null ? void 0 : _e.includes(date))) {
        self.rangeDisabled = (_f = self.rangeDisabled) == null ? void 0 : _f.filter((d) => {
          var _a3;
          return !((_a3 = self.rangeEnabled) == null ? void 0 : _a3.includes(d));
        });
      }
      if (((_g = self.settings.range.disableWeekday) == null ? void 0 : _g.includes(dayID)) && !((_h = self.rangeDisabled) == null ? void 0 : _h.includes(date))) {
        (_i = self.rangeDisabled) == null ? void 0 : _i.push(date);
      }
      setDayModifier(dayEl, dayBtnEl, dayID, date, otherMonth);
      if (otherMonth) {
        if (self.settings.visibility.daysOutside) dayEl.append(dayBtnEl);
      } else {
        dayEl.append(dayBtnEl);
      }
      daysEls[index].append(dayEl);
    };
    const prevMonth = () => {
      const prevMonthDays = new Date(selectedYear, selectedMonth, 0).getDate();
      let day = prevMonthDays - firstDayWeek;
      let year = selectedYear;
      let month = selectedMonth;
      if (selectedMonth === 0) {
        month = self.locale.months.length;
        year = selectedYear - 1;
      } else if (selectedMonth < 10) {
        month = `0${selectedMonth}`;
      }
      for (let i = 0; i < firstDayWeek; i++) {
        day += 1;
        const date = `${year}-${month}-${day}`;
        const dayIDCurrent = new Date(selectedYear, selectedMonth, day - 1);
        const prevMonthID = dayIDCurrent.getMonth() - 1;
        const dayID = new Date(selectedYear, prevMonthID, day).getDay();
        createDay(String(day), dayID, date, true, self.CSSClasses.dayBtnPrev);
      }
    };
    const currentMonth = () => {
      for (let i = 1; i <= daysSelectedMonth; i++) {
        const day = new Date(selectedYear, selectedMonth, i);
        const date = generateDate(day);
        const dayID = day.getDay();
        createDay(String(i), dayID, date, false, null);
      }
    };
    const nextMonth = () => {
      const total = firstDayWeek + daysSelectedMonth;
      const rows = Math.ceil(total / self.locale.weekday.length);
      const nextDays = self.locale.weekday.length * rows - total;
      let year = selectedYear;
      let month = String(selectedMonth + 2);
      if (selectedMonth + 1 === self.locale.months.length) {
        month = "01";
        year = selectedYear + 1;
      } else if (selectedMonth + 2 < 10) {
        month = `0${selectedMonth + 2}`;
      }
      for (let i = 1; i <= nextDays; i++) {
        const day = i < 10 ? `0${i}` : String(i);
        const date = `${year}-${month}-${day}`;
        const dayIDCurrent = new Date(selectedYear, selectedMonth, i);
        const nextMonthID = dayIDCurrent.getMonth() + 1;
        const dayID = new Date(selectedYear, nextMonthID, i).getDay();
        createDay(String(i), dayID, date, true, self.CSSClasses.dayBtnNext);
      }
    };
    prevMonth();
    currentMonth();
    nextMonth();
    createPopup(self, daysEls[index]);
    createWeekNumbers(self, firstDayWeek, daysSelectedMonth, weekNumbersEls[index], daysEls[index]);
  });
  (_b = self.rangeDisabled) == null ? void 0 : _b.sort((a, b) => +new Date(a) - +new Date(b));
};
export {
  createDays as default
};
